import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './BaseService';
import { authenticationService } from './authenticationService';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root',
})
export class NotificationService extends BaseService {
  constructor(http: HttpClient, authenticationSerives: authenticationService) {
    super(http, authenticationSerives, environment.apiUrl + 'Notification');
    this.baseUrl = environment.apiUrl + 'Notification';
  }
  baseUrl: string;

  getByUserId(id: number) {
    return this.http.get<object>(this.baseUrl + '/GetByUser', {
      headers: this.headers,
    });
  }

  makeAsRead(id: number) {
    return this.http.get<object>(this.baseUrl + '/MakeAsRead', {
      headers: this.headers,
    });
  }
  registerForPush = (username: string, token: string) =>
    this.http.post<any>(
      environment.apiUrl + 'Notification/subscribe',
      { token: token },
      { headers: this.headers },
    )

  sendNotification = (notification: any) =>
    this.http.post('pushnotification/send', notification)
}
